import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../../assest/logo.png";
import MiniLogo from "../../../assest/mini_logo.png";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { MdDashboardCustomize, MdReceiptLong } from "react-icons/md";
import { MdDomainAdd } from "react-icons/md";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { MdPayment } from "react-icons/md";
import { MdContactSupport } from "react-icons/md";
import { AiOutlinePlusCircle } from "react-icons/ai";



const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  const { pathname } = location;

  const trigger = useRef(null);
  const sidebar = useRef(null);

  // State for dropdown menu
  const [openDropdown, setOpenDropdown] = useState(null);

  // Close sidebar when clicking outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!sidebar.current || !trigger.current) return;
      if (
        !sidebarOpen ||
        sidebar.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setSidebarOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  }, [sidebarOpen]);

  // Close sidebar on ESC key press
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!sidebarOpen || keyCode !== 27) return;
      setSidebarOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  }, [sidebarOpen]);

  // Toggle dropdown menu
  const toggleDropdown = (id) => {
    setOpenDropdown(openDropdown === id ? null : id);
  };

  return (
    <aside
      ref={sidebar}
      className={`absolute left-0 top-0 z-50 flex h-screen w-[16.125rem] flex-col overflow-y-hidden duration-300 ease-linear text-gray-700 lg:static lg:translate-x-0 ${sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      style={{
        background:
          "radial-gradient(120% 60% at 100% 0%, rgba(249,115,22,0.09) 0%, rgba(249,115,22,0) 55%), linear-gradient(180deg, #FFF9F2 0%, #FFFFFF 22%)",
        boxShadow: "4px 0 24px rgba(0, 0, 0, 0.04)",
        borderRight: "1px solid #F1E4D3",
      }}
    >
     {/* Sidebar Header */}
<div
  className="relative px-6 flex items-center justify-between shrink-0"
  style={{ height: "72px", borderBottom: "1px solid #F1E4D3" }}
>
  <Link to="/" className="flex items-center gap-2">
    {/* Mini logo - chhoti screen (mobile) par */}
    <img
      src={MiniLogo}
      alt="Logo"
      width={40}
      className="drop-shadow-sm sm:hidden"
    />
    {/* Full logo - tablet/desktop par */}
    <img
      src={Logo}
      alt="Logo"
      width={150}
      className="drop-shadow-sm hidden sm:block"
    />
  </Link>

  <button
    ref={trigger}
    onClick={() => setSidebarOpen(!sidebarOpen)}
    aria-controls="sidebar"
    aria-expanded={sidebarOpen}
    className="block lg:hidden text-gray-600"
  >
    ☰
  </button>
</div>

      {/* Sidebar Content */}
      <div className="no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear">
        <nav className="py-4 px-3.5">
          <ul className="mb-6 flex flex-col gap-1.5">
            {sidebarMenu.map((item) => {
              const isParentActive = pathname.startsWith(item.to);
              const isDropdownOpen = openDropdown === item.id;

              return (
                <li key={item.id}>
                  {item.children ? (
                    <>
                      {/* Dropdown Button */}
                      <button
                        onClick={() => toggleDropdown(item.id)}
                        className={`group relative flex w-full items-center justify-between px-3 py-2.5 rounded-xl text-sm transition-all duration-200 ${isParentActive
                          ? "bg-white text-gray-900 font-semibold shadow-[0_4px_14px_rgba(249,115,22,0.14)] border border-orange-100"
                          : "text-gray-600 border border-transparent hover:bg-white hover:shadow-[0_2px_10px_rgba(0,0,0,0.04)] hover:border-orange-100"
                          }`}
                      >
                        {isParentActive && (
                          <span className="absolute left-0 top-1/2 -translate-y-1/2 h-6 w-[3px] rounded-r-full bg-gradient-to-b from-orange-400 to-orange-600" />
                        )}
                        <div className="flex items-center gap-2.5">
                          <span
                            className={`flex h-7 w-7 items-center justify-center rounded-lg transition-all duration-200 ${isParentActive
                              ? "bg-orange-500 text-white shadow-sm shadow-orange-200"
                              : "bg-orange-50/70 text-orange-400 group-hover:bg-orange-100 group-hover:text-orange-500"
                              }`}
                          >
                            {item.icon}
                          </span>
                          {item.label}
                        </div>
                        <span
                          className={`text-xs transition-transform duration-200 ${isDropdownOpen ? "rotate-0 text-orange-500" : "text-gray-400"
                            }`}
                        >
                          {isDropdownOpen ? <IoIosArrowDown /> : <IoIosArrowForward />}
                        </span>
                      </button>

                      {/* Dropdown Submenu */}
                      <ul
                        className={`ml-[2.15rem] pl-3.5 border-l-2 border-orange-100 overflow-hidden transition-all duration-300 ${isDropdownOpen ? "max-h-screen mt-1.5" : "max-h-0"
                          }`}
                      >
                        {item.children.map((subItem) => (
                          <li key={subItem.to}>
                            <Link
                              to={subItem.to}
                              className={`block mt-1 px-3.5 py-2 text-sm rounded-lg transition-colors duration-200 ${pathname === subItem.to
                                ? "bg-orange-500 text-white font-medium shadow-sm shadow-orange-200"
                                : "text-gray-500 hover:bg-orange-50 hover:text-gray-900"
                                }`}
                              onClick={() => setSidebarOpen(false)}
                            >
                              {subItem.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <Link
                      to={item.to}
                      className={`group relative flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm transition-all duration-200 ${pathname === item.to
                        ? "bg-white text-gray-900 font-semibold shadow-[0_4px_14px_rgba(249,115,22,0.14)] border border-orange-100"
                        : "text-gray-600 border border-transparent hover:bg-white hover:shadow-[0_2px_10px_rgba(0,0,0,0.04)] hover:border-orange-100"
                        }`}
                      onClick={() => setSidebarOpen(false)}
                    >
                      {pathname === item.to && (
                        <span className="absolute left-0 top-1/2 -translate-y-1/2 h-6 w-[3px] rounded-r-full bg-gradient-to-b from-orange-400 to-orange-600" />
                      )}
                      <span
                        className={`flex h-7 w-7 items-center justify-center rounded-lg transition-all duration-200 ${pathname === item.to
                          ? "bg-orange-500 text-white shadow-sm shadow-orange-200"
                          : "bg-orange-50/70 text-orange-400 group-hover:bg-orange-100 group-hover:text-orange-500"
                          }`}
                      >
                        {item.icon}
                      </span>
                      {item.label}
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;

// Sidebar menu items with dropdown
const sidebarMenu = [
  {
    id: 1,
    label: "Dashboard",
    icon: <MdDashboardCustomize size={20} />,
    to: "/user/dashboard",
  },
  {
    id: 2,
    label: "Domain Detail",
    to: "/user/domain/detail",
    icon: <MdDomainAdd size={20} />,
  },
  {
    id: 3,
    label: "Invoice Detail",
    to: "/user/invoice/detail",
    icon: <FaFileInvoiceDollar size={20} />,
  },
  {
    id: 4,
    label: "Payment Method",
    to: "/user/payment/method",
    icon: <MdPayment size={20} />,
  },
  {
    id: 5,
    label: "Support",
    to: "/user/support",
    icon: <MdContactSupport size={20} />,
  },
  {
    id: 5,
    label: "Payout",
    to: "/user/reconcilations",
    icon: <MdReceiptLong size={20} />,
  },
  {
    id: 5,
    label: "Add Domain",
    to: "/user/add-domain",
    icon: <AiOutlinePlusCircle size={20} />,
  },
];